import React from "react";
import { MrSelect } from "mr_react_framework";

const SelectInputType = MrSelect({
  config: {
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.label, value: item.value };
      });
    },
    searchApi: false,
    widgetConfig: {
      options: [
        { label: "Input Text", value: "string" },
        { label: "Input With Tags", value: "InputWithTags" },
        { label: "Radio", value: "RadioGroupWidget" },
        { label: "Checkbox", value: "CheckboxGroupWidget" },
      ],
      showSearch: false,
      // filterOption: true,
      optionFilterProp: "label",
      placeholder: "Value",
      style: { width: "100%" },
      // allowClear: true,
    },
  },
});

const SelectSpanValue = MrSelect({
  config: {
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.label, value: item.value };
      });
    },
    searchApi: false,
    widgetConfig: {
      options: [
        { label: "25%", value: 6 },
        { label: "50%", value: 12 },
        { label: "75%", value: 18 },
        { label: "100%", value: 24 },
      ],
      showSearch: false,
      // filterOption: true,
      optionFilterProp: "label",
      placeholder: "Select Span",
      style: { width: "100%" },
      // allowClear: true,
    },
  },
});

const RenderSelect = ({
  value,
  id,
  nestedId,
  span,
  renderSelectedItem,
  onInputChange,
}) => {
  if (span) {
    return (
      <SelectSpanValue
        key={`select-span-section-${Math.floor(Math.random() * 10000) + 1}`}
        id={"span"}
        defaultValue={value}
        onChange={(val) => {
          onInputChange({ name: "span", value: val }, id, nestedId);
        }}
      />
    );
  }

  return (
    <SelectInputType
      key={`select-section-${Math.floor(Math.random() * 10000) + 1}`}
      id={"widget"}
      defaultValue={value}
      onChange={(val) => {
        renderSelectedItem(val, id, nestedId);
        onInputChange({ name: "widget", value: val }, id, nestedId);
      }}
    />
  );
};

export default RenderSelect;
